export default __webpack_public_path__ + "station-defect-fan-gray.png?2211331e3afd469fc8e172d91d921748";